import { render, staticRenderFns } from "./cardV4.vue?vue&type=template&id=29083d6e&scoped=true"
import script from "./cardV4.vue?vue&type=script&lang=js"
export * from "./cardV4.vue?vue&type=script&lang=js"
import style0 from "./cardV4.vue?vue&type=style&index=0&id=29083d6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29083d6e",
  null
  
)

export default component.exports